import { createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from '../../apis'
import axios from 'axios';

import LocalStorage from "../../utils/storage";

const ROLE = LocalStorage.getItem('userRole');

export const createSkuFabricMaterial = createAsyncThunk('createSkuFabricMaterial', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/india-supply/create-sku-material/UI/product_fabric`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const modifyFabric = createAsyncThunk('modifyFabric', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/inventory/fabric/update`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const getVendorPurchaseOrders = createAsyncThunk('getVendorPurchaseOrders', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/vendor-purchase-orders/get-orders`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const createPurchaseOrder = createAsyncThunk('createPurchaseOrder', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/vendor-purchase-orders/create`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const updatePurchaseOrder = createAsyncThunk('updatePurchaseOrder', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/vendor-purchase-orders/update`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const deletePurchaseOrder = createAsyncThunk('deletePurchaseOrder', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/vendor-purchase-orders/delete`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getWarehouseShelves = createAsyncThunk('getWarehouseShelves', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/get-warehouse-shelves`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getVendorsList = createAsyncThunk('getVendorsList', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/get-vendors`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});
